import TimeInputGroup from "./TimeInputGroup";
import { getTimeFieldNames } from "../doorConfigSchema";

function ConfigSwitch({ field, form, onChange }) {
    return (
        <div className="form-check form-switch config-switch">
            <input
                className="form-check-input"
                type="checkbox"
                name={field.name}
                checked={!!form[field.name]}
                onChange={(e) => onChange(field.name, e.target.checked ? 1 : 0)}
            />
        </div>
    );
}

function ConfigTimeField({ field, form, onChange }) {
    const names = getTimeFieldNames(field.prefix);
    const values = names.map((name) => form[name] ?? "00");

    return (
        <TimeInputGroup
            names={names}
            values={values}
            readOnly={field.readOnly || []}
            onChange={onChange}
        />
    );
}

function ConfigThresholdField({ field, form, onChange }) {
    const names = getTimeFieldNames(field.prefix);
    const values = [
        form[`${field.prefix}1`] ?? "0",
        form[`${field.prefix}2`] ?? "0",
        form[`${field.prefix}3`] ?? "0",
    ];

    return (
        <TimeInputGroup
            names={names}
            values={values}
            readOnly={[0, 1]}
            onChange={onChange}
        />
    );
}

function ConfigSelectField({ field, form, onChange }) {
    return (
        <select
            className="form-select"
            value={form[field.name] ?? ""}
            onChange={(e) => onChange(field.name, Number(e.target.value))}
        >
            {field.options.map((option) => (
                <option key={`${field.name}-${option.value}`} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
}

function ConfigNumberField({ field, form, onChange }) {
    return (
        <input
            type="number"
            className="form-control"
            step={field.step || "1"}
            value={form[field.name] ?? ""}
            onChange={(e) => onChange(field.name, e.target.value)}
        />
    );
}

export default function DoorConfigFieldRenderer({ field, form, onChange }) {
    if (field.type === "switch") {
        return <ConfigSwitch field={field} form={form} onChange={onChange} />;
    }
    if (field.type === "select") {
        return <ConfigSelectField field={field} form={form} onChange={onChange} />;
    }
    if (field.type === "number") {
        return <ConfigNumberField field={field} form={form} onChange={onChange} />;
    }
    if (field.type === "time") {
        return <ConfigTimeField field={field} form={form} onChange={onChange} />;
    }
    if (field.type === "threshold") {
        return <ConfigThresholdField field={field} form={form} onChange={onChange} />;
    }
    return null;
}
